module.exports = __webpack_public_path__ + "img/wheel_logo.846ccf06.png";